import {Copy, Check, RotateCcw, Save, CheckCircle2} from 'lucide-react';
import {Ticket} from '../../types';
import {TicketReplyController} from '../../hooks/useTicketReply';
import {Btn, Spinner} from '../Shared';

type ActionProps = {ticket: Ticket; reply: TicketReplyController};

const ReplyApprovalActions = ({ticket, reply}: ActionProps) => {
  const pending = reply.busy || reply.saving;
  const cannotShare = !reply.draft.trim() || pending;
  const approved = ticket.approved && !reply.dirty;
  return <div>
    {reply.dirty && <Btn disabled={pending} onClick={() => reply.save()} data-testid="draft-save"><Save size={12}/>Save</Btn>}
    <Btn onClick={reply.copy} disabled={cannotShare} data-testid="draft-copy"><Copy size={12}/>Copy</Btn>
    <Btn className="primary" onClick={() => reply.save(true)} disabled={cannotShare || approved} data-testid="draft-approve">
      {reply.saving ? <Spinner/> : <Check size={13}/>} {approved ? 'Approved' : 'Approve reply'}
    </Btn>
  </div>;
};

export const DraftActions = ({ticket, reply}: ActionProps) => <div className="reply-actions">
  <Btn className="ghost" onClick={reply.regenerate} disabled={reply.busy || reply.saving} data-testid="draft-regenerate">
    {reply.busy ? <Spinner/> : <RotateCcw size={12}/>} {ticket.draft ? 'Regenerate' : 'Generate reply'}
  </Btn>
  <ReplyApprovalActions ticket={ticket} reply={reply}/>
</div>;

export const ResolutionActions = ({ticket, reply}: ActionProps) => <div className="reply-actions" style={{marginTop: 22}}>
  <span className="privacy-badge" data-testid="draft-language">{ticket.language !== 'Unknown' ? `${ticket.language} conversation` : ''}</span>
  <Btn onClick={reply.resolve} disabled={reply.busy || reply.saving} data-testid="ticket-resolve">
    <CheckCircle2 size={13}/>{ticket.status === 'resolved' ? 'Reopen ticket' : 'Mark as resolved'}
  </Btn>
</div>;